// extracted by mini-css-extract-plugin
module.exports = {"header":"packerSpeedReport_header__12peK","heading":"packerSpeedReport_heading__sYRW9","filter-container":"packerSpeedReport_filter-container__1bs-x"};